// Styles for CardPointsList

import styled from 'styled-components';

export const StyledCardPointsList = styled.div`
  .m-cobrand-PointsCard:last-child {
    margin-bottom: 0;
  }
`;
